module.exports = __webpack_public_path__ + "static/media/view3.9ead88dd.jpeg";